import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component, Renderer2, AfterViewInit } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { Theme } from '../../theme/theme';
import { ThemeService } from '../../theme/theme.service';
import { TopBarComponent } from '../../layouts/top-bar/top-bar.component';
import { SideMenuComponent } from '../../layouts/side-menu/side-menu.component';
import '@maersk-global/mds-components-core/mc-button';
import '@maersk-global/mds-components-core/mc-label';
import '@maersk-global/mds-components-core/mc-toast';
import { ReplaySubject, takeUntil } from 'rxjs';
import { ToastrService } from '../../services/toastr-service';
import { TelemetryService } from '../../services/telemetry.service'; // Import the TelemetryService
import { ToastrMessage } from '../../models/toastr-message.model';

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, TopBarComponent, SideMenuComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShellComponent implements AfterViewInit {
  title = 'AEMS';
  currentTheme: Theme = Theme.LIGHT; // Set the default theme to light
  toastMessageList: ToastrMessage[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private themeService: ThemeService,
    private renderer: Renderer2,
    public toastrService: ToastrService,
    private telemetryService: TelemetryService, // Inject the TelemetryService
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.themeService.setTheme(this.currentTheme, this.renderer);
    this.title = $localize`${this.title}`;
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.telemetryService.logScreenSize(); // Log screen size using the Telemetry

    this.toastrService
      .getToastMessage()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((toast) => {
        let index: number = this.toastMessageList.findIndex((item) => item.message.toLowerCase() === toast.message.toLowerCase());
        if (index === -1 && toast.type) {
          this.toastMessageList.push({
            message: toast.message,
            htmlMessage: toast.htmlMessage,
            type: toast.type,
            heading: toast.heading === '' ? undefined : toast.heading,
            duration: toast.duration,
          });
          // Force synchronous CD so mc-toast[open] renders immediately
          // (avoids the ~16 ms rAF delay from eventCoalescing).
          this.cdr.detectChanges();
          const dismissAfter = toast.duration ?? 3000;
          setTimeout(() => {
            const idx = this.toastMessageList.findIndex((item) => item.message === toast.message);
            if (idx !== -1) this.toastMessageList.splice(idx, 1);
          }, dismissAfter);
        }
      });
  }
}
